import React from "react";
import Download from "./components/Download";
import Features from "./components/Features";

import Header from "./components/Header";
import Hero from "./components/Hero";
import Screenshots from "./components/Screenshots";
import "./styles.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivacyPolicy from "./components/PrivacyPolicy";

function App() {
  const [scrollPosition, setScrollPosition] = React.useState(0);
  const scrollContainerRef = React.useRef(null);
  const [viewportHeight, setViewportHeight] = React.useState(window.innerHeight);
  const [scrollIndex, setScrollIndex] = React.useState(0);

  const primaryColor = "#aab5cf";
  const secondaryColor = "#fdfdfd";
  const thirdColor = "#c0cbe2";

  const bgFromIndex = (i) => {
    if (i === 0) {
      return primaryColor;
    } else if (i % 2 === 1) {
      return secondaryColor;
    } else {
      return thirdColor;
    }
  };

  const reverseBgColor = (color) => {
    if (color === primaryColor) return secondaryColor;
    else if (color === secondaryColor) return thirdColor;
    else if (color === thirdColor) return secondaryColor;
  };

  const menuBgFromIndex = (i) => {
    return reverseBgColor(bgFromIndex(i));
  };

  React.useEffect(() => {
    const handleScroll = () => {
      const position = scrollContainerRef.current.scrollTop;
      setScrollPosition(position);
    };

    const element = scrollContainerRef.current;
    element.addEventListener("scroll", handleScroll);

    return () => {
      element.removeEventListener("scroll", handleScroll);
    };
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  React.useEffect(() => {
    setScrollIndex(Math.floor(scrollPosition / viewportHeight));
  }, [scrollPosition]);

  return (
    <Router>
      <div className="App" ref={scrollContainerRef}>
        <Header
          scrollPosition={scrollPosition}
          viewportHeight={viewportHeight}
          scrollIndex={scrollIndex}
          menuBgFromIndex={menuBgFromIndex}
        />

        <Routes>
          <Route path="/" element={
            <>
              <Hero index={0} bgFromIndex={bgFromIndex} />
              <Features index={1} bgFromIndex={bgFromIndex} />
              <Screenshots index={2} bgFromIndex={bgFromIndex} />
              <Download index={3} bgFromIndex={bgFromIndex} />
            </>
          } />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
